<template>
  <b-card body-bg-variant="light"
          class="ma-4"
          header="Team dashboard"
          header-bg-variant="info"
          header-class="color-lighten"
          header-text-variant="light">
    <h4>Proposals submitted during last call:</h4>
    <b-table :busy="isBusy"
             :current-page="currentPage"
             :fields="fields"
             :items="proposals"
             :per-page="perPage"
             head-variant="light"
             hover
             responsive
             striped>
      <template v-slot:top-row="{fields}">
        <proposal-filter :id="id"
                         v-model="proposals"
                         :fields="fields"
                         :not-include-key="['actions','ordinalNumber']"/>
      </template>

      <template v-slot:cell(ordinalNumber)="row">
        <base-column-ordinal-number v-bind="{index: row.index, perPage: perPage, currentPage: currentPage}"/>
      </template>

      <template v-slot:cell(actions)="row">
        <base-icon-button-people @click="goToTeam(row)"/>
      </template>
    </b-table>
    <b-table-footer v-model="loading"
                    :current-page="currentPage"
                    :data-length="proposals.length"
                    :per-page="perPage"
                    @change-page="changePage">
      <template v-slot>
        <base-per-page-input v-model="perPage"/>
      </template>
    </b-table-footer>
  </b-card>
</template>

<script>
  import BaseIconButtonPeople from '@/components/base-components/base-icons/BaseIconButtonPeople';
  import BTableFooter from '@/components/BTableFooter';
  import ProposalFilter from '@/components/ProposalFilter';
  import BaseColumnOrdinalNumber from '@/components/base-components/BaseColumnOrdinalNumber';
  import { ordinalNumber } from '@/helpers/commonTableColumns';
  import BasePerPageInput from '@/components/base-components/BasePerPageInput';

  export default {
    name: 'TeamDashboard',
    components: {
      BaseIconButtonPeople,
      ProposalFilter,
      BTableFooter,
      BaseColumnOrdinalNumber,
      BasePerPageInput,
    },
    data() {
      return {
        id: 1,
        loading: false,
        currentPage: 1,
        perPage: 10,
        isBusy: false,
        proposals: [],
        fields: [
          ordinalNumber,
          {
            key: 'document_specification.document_id',
            label: 'ID',
            class: 'custom-column-id-width',
          },
          'title',
          {
            key: 'document_specification.type',
            label: 'Infrastructure',
          },
          'actions',
        ],
      };
    },
    methods: {
      loadData() {
        this.loading = true;
        // eslint-disable-next-line camelcase
        const callStates = { call_states: 'submissionClosed experiment' };
        this.axios.get(
          '/documents/me/active',
          { params: callStates },
        )
          .then((response) => {
            this.proposals = response.data;
            this.$emit('setup-proposal', this.proposals);
            this.loading = false;
          });
      },
      goToTeam(row) {
        const proposalId = this.getId(row.item);
        this.$router.push(`/proposals/${proposalId}/team`);
      },
      changePage(val) {
        this.currentPage = val;
      },
    },
    created() {
      this.loadData();
    },
  };
</script>

<style scoped>

</style>
